class SiteHeader {
    constructor (theme, elem) {
        this.name = this.constructor.name
        this._theme = theme
        this._elem = elem
        this._triangle = null
        this._menuItems = null
        this._searchBar = null
        this._searchButton = null
    }

    onInit () {
        document.addEventListener('scroll', e => { this.checkScroll(e) })
        this._triangle = this._elem.querySelector('.site-header__menu__triangle')
        this._menuItems = this._elem.querySelectorAll('.site-header__menu__item')
        if (this._triangle && this._menuItems.length > 0) {
            for (var i = 0; i < this._menuItems.length; i++) {
                this._menuItems[i].addEventListener('mouseover', e => { this.moveTriangle(e.currentTarget) })
                this._menuItems[i].addEventListener('mouseleave', e => { this._triangle.classList.remove('site-header__menu__triangle--visible') })
            }
        }

        this._searchBar = this._elem.querySelector('.site-header__search')
        this._searchButton = this._elem.querySelector('.site-header__actions__search')

        if (this._searchButton && this._searchBar) {
            this._searchButton.addEventListener('click', e => { e.preventDefault(); this.openSearch() })
        }
        if (this._searchBar) {
            let shadow = this._searchBar.querySelector('.site-header__search__shadow')
            if (shadow) {
                shadow.addEventListener('click', e => { this.closeSearch() })
            }
            let close = this._searchBar.querySelector('.site-header__search__close')
            if (close) {
                close.addEventListener('click', e => { this.closeSearch() })
            }
        }
        document.body.style.marginTop = `${this._elem.offsetHeight}px`
    }
    checkScroll (e) {
        // if (scrollY > 100) {
        //     this._elem.classList.add('site-header--transparent')
        // } else {
        //     this._elem.classList.remove('site-header--transparent')
        // }
    }
    moveTriangle (el) {
        this._triangle.classList.remove('site-header__menu__triangle--visible')
        let offset = 10
        if (el === this._menuItems[0]) {
            offset = 0
        }
        if (el === this._menuItems[this._menuItems.length - 1]) {
            offset = 20
        }
        this._triangle.style.left = `${el.offsetLeft + (el.offsetWidth / 2) - offset}px`
        if (el.classList.contains('has-links')) {
            this._triangle.classList.add('site-header__menu__triangle--visible')
        }
    }
    openSearch () {
        if (!this._searchBar.classList.contains('site-header__search--active')) {
            this._searchBar.classList.add('site-header__search--active')
        }
    }
    closeSearch () {
        this._searchBar.classList.remove('site-header__search--active')
    }
}

export default SiteHeader



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SiteHeader.js